export const dataTestIds = {
	// Chat button
	chatbotButtonOpen: 'chatbot.button.open',
	// Chat form
	chatbotInputForm: 'chatbot.input.form',
	// About AI message
	aboutAIMessage: 'chatbot.about.ai',
}
